import dashboardSopCategoriesSectionImage from "../../../assets/images/dashboard-sop/dashboard-sop-categories-section.png";
import dashboardSopCustomersSectionImage from "../../../assets/images/dashboard-sop/dashboard-sop-customers-section.png";
import dashboardSopDateRangeImage from "../../../assets/images/dashboard-sop/dashboard-sop-date-range.png";
import dashboardSopEmployeesSectionImage from "../../../assets/images/dashboard-sop/dashboard-sop-employees-section.png";
import dashboardSopOrdersSectionImage from "../../../assets/images/dashboard-sop/dashboard-sop-orders-section.png";
import dashboardSopProductItemsChartImage from "../../../assets/images/dashboard-sop/dashboard-sop-product-items-chart.png";
import dashboardSopProductsSectionImage from "../../../assets/images/dashboard-sop/dashboard-sop-products-section.png";
import dashboardSopStoreSelectorImage from "../../../assets/images/dashboard-sop/dashboard-sop-store-selector.png";
import dashboardSopStoresSectionImage from "../../../assets/images/dashboard-sop/dashboard-sop-stores-section.png";
import dashboardSopSuppliersSectionImage from "../../../assets/images/dashboard-sop/dashboard-sop-suppliers-section.png";

import type { DashboardSopImageConfig } from "../types";

export const DASHBOARD_SOP_IMAGES: Record<string, DashboardSopImageConfig> = {
  "date-range": {
    src: dashboardSopDateRangeImage,
    altKey: "dashboard-sop-image-date-range-alt",
    altFallback:
      "Date range picker with quick presets and a calendar for custom dates"
  },
  "store-selector": {
    src: dashboardSopStoreSelectorImage,
    altKey: "dashboard-sop-image-store-selector-alt",
    altFallback:
      "Store dropdown on the dashboard showing All stores and individual store options"
  },
  "orders-section": {
    src: dashboardSopOrdersSectionImage,
    altKey: "dashboard-sop-image-orders-section-alt",
    altFallback: "Orders dashboard section with order counts and status charts"
  },
  "products-section": {
    src: dashboardSopProductsSectionImage,
    altKey: "dashboard-sop-image-products-section-alt",
    altFallback:
      "Products dashboard section with product counts and status charts"
  },
  "product-items-chart": {
    src: dashboardSopProductItemsChartImage,
    altKey: "dashboard-sop-image-product-items-chart-alt",
    altFallback:
      "Product items by state bar chart showing in stock and sold counts"
  },
  "categories-section": {
    src: dashboardSopCategoriesSectionImage,
    altKey: "dashboard-sop-image-categories-section-alt",
    altFallback:
      "Categories dashboard section with total count and status chart"
  },
  "stores-section": {
    src: dashboardSopStoresSectionImage,
    altKey: "dashboard-sop-image-stores-section-alt",
    altFallback: "Stores dashboard section with total count and status chart"
  },
  "employees-section": {
    src: dashboardSopEmployeesSectionImage,
    altKey: "dashboard-sop-image-employees-section-alt",
    altFallback:
      "Employees dashboard section with team counts and role breakdown"
  },
  "customers-section": {
    src: dashboardSopCustomersSectionImage,
    altKey: "dashboard-sop-image-customers-section-alt",
    altFallback:
      "Customers dashboard section with customer counts and type chart"
  },
  "suppliers-section": {
    src: dashboardSopSuppliersSectionImage,
    altKey: "dashboard-sop-image-suppliers-section-alt",
    altFallback:
      "Suppliers dashboard section with vendor counts and status chart"
  }
};
